import { useState, useEffect } from 'react';
import { api } from '../api';

// #163 — extraído de Users.js a su propio archivo (mismo criterio que
// HardDeleteClientModal en el #112): Users.js importa react-router-dom, que
// react-scripts test no resuelve, así que el modal no era testeable ahí.
export function NotificationPrefsModal({ user, onClose }) {
  const DEFAULTS = {
    channel: 'email', notify_job_error: true, notify_job_warning: true,
    notify_daily_summary: true, notify_audit_events: false,
    notify_job_ok: false, notify_storage_alert: true, notify_system_alerts: false,
    telegram_chat_id: '', email: '',
  };
  const [form, setForm]   = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');
  const [saved, setSaved]     = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // Sin Chat ID el backend rechaza telegram/both con un 400 (ver
  // update_notification_prefs en users.py). Deshabilitamos guardar en vez de
  // dejar apretar para el rechazo.
  const telegramSinDestino = (form.channel === 'telegram' || form.channel === 'both') && !form.telegram_chat_id;

  const isAdminOrOp = ['admin', 'operator'].includes(user.role);
  const isClient    = user.role === 'client';
  const isReseller  = user.role === 'reseller';

  const inpStyle = { width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 10px', fontFamily: 'var(--mono)', fontSize: 12, outline: 'none', boxSizing: 'border-box' };
  const lblStyle = { display: 'block', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 5, fontFamily: 'var(--mono)' };

  const Toggle = ({ k, label }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: 13 }}>{label}</span>
      <div onClick={() => set(k, !form[k])} style={{ width: 36, height: 20, borderRadius: 10, cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0, background: form[k] ? 'var(--accent)' : 'var(--border)', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 2, width: 16, height: 16, borderRadius: '50%', background: 'white', transition: 'left 0.2s', left: form[k] ? 18 : 2 }} />
      </div>
    </div>
  );

  useEffect(() => {
    api.getNotificationPrefs(user.id)
      .then(p => setForm({ ...DEFAULTS, ...p, telegram_chat_id: p.telegram_chat_id || '', email: p.email || '' }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user.id]); // eslint-disable-line

  const submit = async () => {
    setSaving(true);
    setError('');
    try {
      await api.updateNotificationPrefs(user.id, {
        ...form,
        telegram_chat_id: form.telegram_chat_id || null,
        email: form.email || null,
      });
      setSaved(true);
      setTimeout(onClose, 800);
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', width: 480, maxHeight: '90vh', display: 'flex', flexDirection: 'column', clipPath: 'polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px))' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <span style={{ fontFamily: 'var(--mono)', fontSize: 14, letterSpacing: 1 }}>NOTIFICACIONES</span>
            <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 3 }}>{user.email}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
        </div>

        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: 'var(--muted)', fontFamily: 'var(--mono)', fontSize: 12 }}>CARGANDO...</div>
        ) : (
          <div style={{ padding: 24, overflowY: 'auto', flex: 1 }}>
            {error && <div style={{ background: 'rgba(255,77,109,0.1)', border: '1px solid var(--red)', color: 'var(--red)', padding: '10px 14px', fontSize: 12, fontFamily: 'var(--mono)', marginBottom: 16 }}>{error}</div>}
            {saved && <div style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid var(--green)', color: 'var(--green)', padding: '10px 14px', fontSize: 12, fontFamily: 'var(--mono)', marginBottom: 16 }}>✓ Guardado</div>}

            {/* Canal */}
            <div style={{ marginBottom: 20 }}>
              <label style={lblStyle}>Canal de notificaciones</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {[['telegram', 'Telegram'], ['email', 'Email'], ['both', 'Ambos']].map(([v, l]) => (
                  <button key={v} onClick={() => set('channel', v)} style={{
                    flex: 1, padding: '8px 0', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer',
                    background: form.channel === v ? 'var(--accent)' : 'transparent',
                    border: `1px solid ${form.channel === v ? 'var(--accent)' : 'var(--border)'}`,
                    color: form.channel === v ? 'var(--bg)' : 'var(--text)', fontWeight: form.channel === v ? 700 : 400,
                  }}>{l}</button>
                ))}
              </div>
            </div>

            {/* Contact info */}
            {(form.channel === 'telegram' || form.channel === 'both') && (
              <div style={{ marginBottom: 16 }}>
                <label style={lblStyle}>Chat ID de Telegram</label>
                <input value={form.telegram_chat_id} onChange={e => set('telegram_chat_id', e.target.value)} placeholder="Obtener con @userinfobot" style={inpStyle} />
                {!form.telegram_chat_id && (
                  <div style={{ fontSize: 11, color: 'var(--yellow)', marginTop: 6 }}>
                    Sin Chat ID no se puede guardar Telegram como canal — las notificaciones no tendrían destino.
                  </div>
                )}
              </div>
            )}
            {(form.channel === 'email' || form.channel === 'both') && (
              <div style={{ marginBottom: 16 }}>
                <label style={lblStyle}>Email para notificaciones</label>
                <input value={form.email} onChange={e => set('email', e.target.value)} placeholder={user.email} style={inpStyle} />
              </div>
            )}

            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 8 }}>
              <div style={{ fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 12, fontFamily: 'var(--mono)' }}>
                {isAdminOrOp ? 'Notificaciones de sistema' : 'Mis notificaciones'}
              </div>

              {isAdminOrOp && (
                <>
                  <Toggle k="notify_job_error"     label="Jobs con error" />
                  <Toggle k="notify_job_warning"   label="Jobs con warning" />
                  <Toggle k="notify_daily_summary" label="Resumen diario" />
                  <Toggle k="notify_audit_events"  label="Eventos de auditoría" />
                  <Toggle k="notify_system_alerts" label="Alertas de sistema (rate limiter, servidores caídos)" />
                </>
              )}
              {isClient && (
                <>
                  <Toggle k="notify_job_ok"        label="Jobs exitosos" />
                  <Toggle k="notify_job_error"     label="Jobs con error/warning" />
                  <Toggle k="notify_storage_alert" label="Alerta de storage (85%)" />
                </>
              )}
              {isReseller && (
                <>
                  <Toggle k="notify_job_ok"        label="Jobs exitosos" />
                  <Toggle k="notify_job_error"     label="Jobs con error" />
                  <Toggle k="notify_job_warning"   label="Jobs con warning" />
                  <Toggle k="notify_daily_summary" label="Resumen diario" />
                  <Toggle k="notify_storage_alert" label="Alerta de storage (85%)" />
                </>
              )}
            </div>
          </div>
        )}

        <div style={{ padding: '14px 24px', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0 }}>
          <button onClick={onClose} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text)', padding: '7px 14px', fontSize: 12, fontFamily: 'var(--mono)', cursor: 'pointer' }}>CANCELAR</button>
          <button onClick={submit} disabled={saving || telegramSinDestino} style={{ background: 'var(--accent)', border: '1px solid var(--accent)', color: 'var(--bg)', padding: '7px 14px', fontSize: 12, fontFamily: 'var(--mono)', cursor: (saving || telegramSinDestino) ? 'not-allowed' : 'pointer', opacity: (saving || telegramSinDestino) ? 0.5 : 1, fontWeight: 700 }}>
            {saving ? 'GUARDANDO...' : 'GUARDAR →'}
          </button>
        </div>
      </div>
    </div>
  );
}
